import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import LoginPage from 'pages/LoginPage';
import SignUpPage from 'pages/SignUpPage';
import { validateAuthCookie } from 'utils/functions/authentication';

const LoginRoute = ({ isLogin }) => {
  const isUserAuthenticated = validateAuthCookie();

  return isUserAuthenticated ? (
    <Navigate to="/bulkOrder" />
  ) : (
    (isLogin && <LoginPage />) || <SignUpPage />
  );
};

LoginRoute.propTypes = {
  isLogin: PropTypes.bool,
};

LoginRoute.defaultProps = {
  isLogin: false,
};

export default LoginRoute;
